module.exports = __webpack_public_path__ + "static/pattern-0e576981f20602db98e0ab9f8f0725fc.png";